// import Vue from 'vue'

const state = {
  visible: false
}

const getters = {
  visible: state => state.visible
}

const actions = {
  toggleHeader ({ commit }, payload) {
    commit(`TOGGLE_HEADER`, payload)
  }
}

const mutations = {
  TOGGLE_HEADER (state, payload) {
    state.visible = payload || payload === false ? payload : !state.visible
  }
}

export default {
  namespaced: true,

  state,
  getters,
  actions,
  mutations
}
